import { render, staticRenderFns } from "./Kyc.vue?vue&type=template&id=5a8560f0"
import script from "./Kyc.vue?vue&type=script&lang=js"
export * from "./Kyc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports